var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#000"},[React.createElement("path",{"d":"M147.75,20H10A10,10,0,0,1,10,0H147.75a10,10,0,0,1,0,20Z","key":0}),React.createElement("path",{"d":"M147.75,116.48H10a10,10,0,0,1,0-20H147.75a10,10,0,0,1,0,20Z","key":1}),React.createElement("path",{"d":"M147.75,68.24H10a10,10,0,0,1,0-20H147.75a10,10,0,1,1,0,20Z","key":2})]));
}

Menu.defaultProps = {"viewBox":"0 0 157.75 116.48"};

module.exports = Menu;

Menu.default = Menu;
